import React, { useEffect, useRef, useState } from "react";
import { OverallComponent } from "./Overall";
import BuildUpPlay from "./BuildUpPlay";
import Defence from "./Defence";
import Physical from "./Physical";
import { FinalThird } from "./FinalThird";
import { TagsComponent } from "./Tags";
import { IPlayerAttributesData, IPlayerAttributesPitchData } from "../../../types/IPlayerAttributesData";
import IApiResponse from "../../../types/IApiResponse";
import { postData } from "../../../services/api";
import handleApiResponse from "../../../utils/handleApiResponse";
import apiUrls from "../../../config/apiUrls";
import { useLoading } from "../../../contexts/LoadingContext";
import ScorePlayerHeader from "./ScorePlayerHeader";
import { styled } from "styled-components";
import { IOption } from "../../../types/IOption";
import CustomDropdown from "../../../ui/CustomDropdown";
import { fetchData } from "../../../services/api";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import LabelNumber from "../../../styled-components/LabelNumber";
import { useTheme } from "../../../contexts/ThemeContext";
import CustomizedTooltips from "../../../ui/Tooltip";
import { RolesPlayed } from "./RolesPlayed";
import { IPlayerCardData } from "../../../types/IPlayerDetail";
import { AttributesTable } from "./AttributesTable";
interface PlayerAttributeProps {
  playerData: IPlayerCardData | undefined;
  playerId: number;
  playerName: string;
  club?: number;
  isGoalKeeper?: boolean;
}

const ScorePlayer = styled.div`
  background: ${({ theme }) => theme.playerCardBackground};
`;
const HeaderContent = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

const Attributes: React.FC<PlayerAttributeProps> = ({ playerData, playerId, playerName, club, isGoalKeeper }) => {
  const { startLoading, stopLoading } = useLoading();
  const { seasonId, setSeasonId } = useSearch();
  const { theme } = useTheme();
  const [selectedPosition, setSelectedPosition] = useState<"theirposition" | "allpositions">("theirposition");
  const [selectedAttributeScore, setSelectedAttributeScore] = useState<string>("league");
  const [attributesData, setAttributesData] = useState<IPlayerAttributesData | undefined>();
  const [attributesPitchData, setAttributesPitchData] = useState<IPlayerAttributesPitchData[]>([]);
  const [isSticky, setIsSticky] = useState(false);
  const [seasonData, setSeasonData] = useState<IOption[]>([]);
  const [currentSeason, setcurrentSeason] = useState<string>();
  const [currentTeamlogoURL , setCurrentTeamLogoUrl] = useState<string[]>([])
  const [activeSection, setActiveSection] = React.useState<
    "Seasonbreakdown" | "Rolesplayed" | "Tags" | "Attributes"
  >("Seasonbreakdown");
  const sectionRefs = {
    Tags: useRef<HTMLDivElement>(null),
    Attributes: useRef<HTMLDivElement>(null),
    Seasonbreakdown: useRef<HTMLDivElement>(null),
    Rolesplayed: useRef<HTMLDivElement>(null),
  };
  const scorePlayerRef = useRef<HTMLDivElement | null>(null);

  const fetchAttributesOnPitchData = async () => {
    if (playerId > 0) {
      try {
        startLoading();
        const requestData = {
          attributeName: "",
          playerId: playerId
        };
        const playersData: IPlayerAttributesPitchData[] = await postData(apiUrls.GetAttributesOnPitch, requestData);
        setAttributesPitchData(playersData);

      }
      catch (error) {
        stopLoading();
        console.error("Error fetching AttributesOnPitch Data:", error);
      }
    }
  }

  useEffect(() => {
    const fetchSeasonData = async () => {
      const response: IApiResponse<any> = await fetchData(`${apiUrls["GetAllCompetitionSeasonsByPlayerId"]}?PlayerId=${playerId}`);
      handleApiResponse(
        response,
        (teamsData) => {
          setSeasonData(teamsData);
          const currentSeasonValue = teamsData[0]?.value;
          const currentSeason = teamsData[0]?.label;
          const currentTeamLogoUrl = teamsData[0]?.teams?.map((team : any)=> team.teamLogoURL)
          setCurrentTeamLogoUrl(currentTeamLogoUrl)
          setSeasonId(Number(currentSeasonValue));
          setcurrentSeason(currentSeason);
        },
        (error) => {
          console.error("Error fetching season Data:", error);
        }
      );
    };
    fetchSeasonData();
    fetchAttributesOnPitchData();
  }, [playerId]);


  const fetchAttributesData = async () => {
    if (seasonId > 0) {
      try {
        startLoading();
        const ApiRequestData = {
          playerId: playerId,
          AllPosition: selectedPosition === "allpositions",
          AttributeScoreFor: selectedAttributeScore,
          seasonId: seasonId,
        };
        const response: IApiResponse<IPlayerAttributesData> = await postData(apiUrls.GetPlayerAttributes, ApiRequestData);
        handleApiResponse(
          response,
          (attributesData) => {
            setAttributesData(attributesData);
            stopLoading();
          },
          (error) => {
            console.error(error);
            stopLoading();
          }
        );
      } catch (error) {
        stopLoading();
        console.error("Error fetching PlayerAttributes data:", error);
      }
    }
  };

  useEffect(() => {
    fetchAttributesData();
  }, [playerId, selectedAttributeScore, seasonId]);

  const handleSeasonChange = (seasonId: string) => {
    setSeasonId(Number(seasonId));
  };


  useEffect(() => {
    const handleScroll = () => {
      const windscroll = window.scrollY;
      if (scorePlayerRef.current) {
        const scorePlayerTop = scorePlayerRef.current.offsetTop; //scorePlayerRef.current.getBoundingClientRect().top;
        const header = document.querySelector(".page-header") as HTMLElement | null;
        const tabs = document.querySelector(".tab-section") as HTMLElement | null;
        const headerHeight = header?.offsetHeight || 0;
        const tabsHeight = tabs?.offsetHeight || 0;
        const totalOffset = headerHeight + tabsHeight;
        if (window.scrollY >= scorePlayerTop - totalOffset + 500) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }
      const scorePlayerHeight = scorePlayerRef.current?.offsetHeight || 0;
      Object.entries(sectionRefs).forEach(([section, ref]) => {
        const element = ref.current;
        if (element) {
          const sectionTop = element.getBoundingClientRect().top + window.scrollY;
          const sectionHeight = element.offsetHeight;
          const header = document.querySelector(".page-header") as HTMLElement | null;
          const tabs = document.querySelector(".tab-section") as HTMLElement | null;
          const headerHeight = header?.offsetHeight || 0;
          const tabsHeight = tabs?.offsetHeight || 0;
          const offset = 3;
          let totalOffset = headerHeight + tabsHeight + offset + scorePlayerHeight;
          // Detect if the section is currently in view (adjust offset for sticky header height if needed)
          if (windscroll >= sectionTop - totalOffset && windscroll < sectionTop + sectionHeight - 271) {
            setActiveSection(section as "Seasonbreakdown" | "Tags" | "Attributes" | "Rolesplayed");
          }
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleHeaderClick = (section: "Seasonbreakdown" | "Tags" | "Attributes" | "Rolesplayed") => {
    setActiveSection(section);
    const element = sectionRefs[section].current;
    if (element) {
      const sectionTop = element.getBoundingClientRect().top + window.scrollY;
      const header = document.querySelector(".page-header") as HTMLElement | null;
      const tabs = document.querySelector(".tab-section") as HTMLElement | null;
      const scorePlayer = document.querySelector(".common-header-two") as HTMLElement | null;
      const headerHeight = header?.offsetHeight || 0;
      const tabsHeight = tabs?.offsetHeight || 0;
      const scorePlayerHeight = scorePlayer?.offsetHeight || 0;
      let scrollPosition;
      const offset = 0; // Desired offset from the top
      // if (section === "Finalthird" || section === "Buildupplay" || section === "Defence" || section === "Physical")
      //   scrollPosition = sectionTop - headerHeight - tabsHeight - scorePlayerHeight - offset;
      // else 
      scrollPosition = sectionTop - headerHeight - tabsHeight - offset;
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }
  };

  const getTooltipText = (teams: any[]) => {
    if (teams.length === 1) return `Playing for: ${teams[0].teamName}`;
    const teamNames = teams.map((team) => team.teamName);
    const lastTeam = teamNames.pop();
    return `Playing for: ${teamNames.join(", ")} & ${lastTeam}`;
  };

  return (
    <div className="player-tab-content">
      <div className="career-container">
        <div className="career-header">
          <div
            className="custom-dropdown season-drodown"
            style={{ flexDirection: attributesData?.playerTeamsForSeason?.length! > 1 ? "column" : "row" }}
          >
            <CustomDropdown
              placeholder="SEASON"
              options={seasonData}
              onChange={handleSeasonChange}
              deafaultSelected={currentSeason}
              currentLogo = {currentTeamlogoURL}
              fromAttributes={true}
              isDisplaySearchInput={false}
            />
            {/* <div className="club-logo-season-changer">
              {attributesData?.playerTeamsForSeason?.map((team, index) => (
                <div key={team.teamId} className="season-team-logo">
                  <CustomizedTooltips title={getTooltipText(attributesData.playerTeamsForSeason)}>
                    <img src={team.teamLogoURL} alt={team.teamName} width={50} />
                  </CustomizedTooltips>
                  {index < attributesData.playerTeamsForSeason.length - 1 && <span>/</span>}
                </div>
              ))}
            </div> */}
          </div>
          <div className="nav-content">
            <ul className="career-navigation">
              <li
                className={`career-nav-item ${activeSection === "Seasonbreakdown" ? "active" : ""}`}
                onClick={() => handleHeaderClick("Seasonbreakdown")}
              >
                <span className="indicator"></span>
                <LabelNumber
                  style={{ color: activeSection === "Seasonbreakdown" ? theme.playerColor : "" }}
                  className="attack-defense-data"
                >
                  Season breakdown
                </LabelNumber>
              </li>
              <li
                className={`career-nav-item ${activeSection === "Attributes" ? "active" : ""}`}
                onClick={() => handleHeaderClick("Attributes")}
              >
                <span className="indicator"></span>
                <LabelNumber style={{ color: activeSection === "Attributes" ? theme.playerColor : "" }} className="attack-defense-data">
                  Attributes
                </LabelNumber>
              </li>
              <li
                className={`career-nav-item ${activeSection === "Rolesplayed" ? "active" : ""}`}
                onClick={() => handleHeaderClick("Rolesplayed")}
              >
                <span className="indicator"></span>
                <LabelNumber
                  style={{ color: activeSection === "Rolesplayed" ? theme.playerColor : "" }}
                  className="attack-defense-data"
                >
                  Roles played
                </LabelNumber>
              </li>
              <li className={`career-nav-item ${activeSection === "Tags" ? "active" : ""}`} onClick={() => handleHeaderClick("Tags")}>
                <span className="indicator"></span>
                <LabelNumber style={{ color: activeSection === "Tags" ? theme.playerColor : "" }} className="attack-defense-data">
                  {" "}
                  Tags
                </LabelNumber>
              </li>
            </ul>
          </div>
        </div>
        <div className="tab-content tab-content-right">
          <div ref={sectionRefs.Seasonbreakdown} id="seasonbreakdown">
            <HeaderContent className="common-header">
              <h3>Season breakdown</h3>
            </HeaderContent>
            <OverallComponent playerData={playerData} overAllData={attributesData} playerId={playerId} seasonId={seasonId} club={club} />
          </div>
          <div ref={sectionRefs.Attributes} id="attributes">
              {/* <AttributesTable selectedPosition={selectedPosition} setSelectedPosition={setSelectedPosition} attributesData={attributesData} /> */}
          </div>
          <div ref={sectionRefs.Rolesplayed} id="rolesplayed">
            {/* <RolesPlayed playerName={playerName} playerId={playerId} /> */}
          </div>
          <div ref={sectionRefs.Tags} id="tags">
            <TagsComponent tagsData={attributesData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Attributes;
